import React from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import {ReactComponent as DropDownIcon} from "../assets/row-down.svg"
import Web3 from "web3";
import Web3Modal from "web3modal";

import image1 from "../assets/image1.png";
import image2 from "../assets/image2.png";
import image3 from "../assets/image3.png";
import image4 from "../assets/image4.png";
import image5 from "../assets/image5.png";
import image6 from "../assets/image6.png";
import image7 from "../assets/image7.png";

const exampleData = [
  { name: 'Azuki', description: 'NO:5296', image: image1 },
  { name: 'Azuki', description: 'NO:5296', image: image2 },
  { name: 'Azuki', description: 'NO:5296', image: image3 },
  { name: 'Azuki', description: 'NO:5296', image: image4 },
  { name: 'Azuki', description: 'NO:5296', image: image5 },
  { name: 'Azuki', description: 'NO:5296', image: image6 },
  { name: 'Azuki', description: 'NO:5296', image: image7 },
  { name: 'Azuki', description: 'NO:5296', image: image1 },
  { name: 'Azuki', description: 'NO:5296', image: image2 },
  { name: 'Azuki', description: 'NO:5296', image: image3 },
  { name: 'Azuki', description: 'NO:5296', image: image4 },
  { name: 'Azuki', description: 'NO:5296', image: image5 },
  { name: 'Azuki', description: 'NO:5296', image: image6 },
  { name: 'Azuki', description: 'NO:5296', image: image7 },
  { name: 'Azuki', description: 'NO:5296', image: image1 },
]


function Shop() {
  const [walletConnected, setWalletConnected] = useState(false);
  const [pagelocation, setPageLocation] = useState(useLocation().pathname);

  // Connect Wallet
  const connectWallet = async () => {
    if (Web3.givenProvider) {
      const providerOptions = {};

      const web3Modal = new Web3Modal({
        network: "mainnet",
        cacheProvider: true,
        providerOptions,
      });

      const provider = await web3Modal.connect();
      const web3 = new Web3(provider);

      web3.eth.net.getId();

      const addresses = await web3.eth.getAccounts();
      const address = addresses[0];

      const { ethereum } = window;

      const networkId = await ethereum.request({
        method: "net_version",
      });

      setWalletConnected(true);
    } else {
      window.open(
        `https://metamask.app.link/dapp/hit-cat.netlify.app${pagelocation}`
      );
    }
  };
  return (<>
    <section className="shop">
      <div className="container">
        <div className="shop-wrapper">
          {!walletConnected && (
            <div className="connect-wallet-alert">
              <button onClick={connectWallet} className="connect-wallet-btn">
                Connect Wallet
              </button>
            </div>
          )}
          <div className="shop-left">
            <button className="gallery-attribute-btn">
              <span>Type</span> <DropDownIcon className="drop-down-icon" />
            </button>
            <button className="gallery-attribute-btn">
              <span>Special</span> <DropDownIcon className="drop-down-icon" />
            </button>
            <button className="gallery-attribute-btn">
              <span>Clothing</span> <DropDownIcon className="drop-down-icon" />
            </button>
            <button className="gallery-attribute-btn">
              <span>Off Hand</span> <DropDownIcon className="drop-down-icon" />
            </button>
            <button className="gallery-attribute-btn">
              <span>Hair</span> <DropDownIcon className="drop-down-icon" />
            </button>
            <button className="gallery-attribute-btn">
              <span>HeadGear</span> <DropDownIcon className="drop-down-icon" />
            </button>
            <button className="gallery-attribute-btn">
              <span>Face</span> <DropDownIcon className="drop-down-icon" />
            </button>
            <button className="gallery-attribute-btn">
              <span>Neck</span> <DropDownIcon className="drop-down-icon" />
            </button>
          </div>
          <div className="shop-right">
            <div className="shop-grid">
              {exampleData.map(i => (
                <div className="item-container">
                  <img className="item-img" src={i.image} alt="" />
                  <div className="item-info">
                    <span className="item-info-name">{i.name}</span>
                    <span className="item-info-desc">{i.description}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>


      </div>

    </section>



  </>


  );
}

export default Shop;